import React from 'react';
import { BuildIcon } from 'styles/components/Icons';
import T from 'mrf/utils/T';

export default function UnderConstruction({ title }) {
    return (
        <div className="flex flex-col items-center justify-center w-full min-h-container">
            <h5>
                <BuildIcon size="40"/> {title}
            </h5>
            <p>
                <T>
                    This feature is under construction and will be released soon.
                </T>
            </p>
        </div>
    );
}
